import React, { useState } from "react";
import { Popup } from 'witmeg-ui-system';
import "./EmailVerifyModal.scss"
import close from "../../../assets/close.svg"
import CodeInput from "../../../components/CodeInput/CodeInput";

const EmailVerifyModal = ({ visibility, onPopupClose, codes, setCodes, isVerifyLoading, onVerify }) => {
    const [error, setError] = useState(false)

    return (
        <Popup
            className='EmailVerifyModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={() => {
                onPopupClose()
            }}
            closable={false}>
            <div className="modal-inner">
                <div className="modal-inner-header-container">
                    <div className="modal-inner-header-wrapper">
                        <div className="modal-inner-title-text">
                            Verify Your Email
                        </div>
                        <img className="close-icon" alt="" src={close}
                            onClick={() => {
                                onPopupClose()

                            }} />
                    </div>
                </div>
                <div className="modal-inner-wrap">
                    <div className="input-containers">
                        <div className="form-label-wrapper">Verification Code</div>
                        <CodeInput codes={codes} setCodes={setCodes} error={error} setError={setError} />
                        {error && <div className="input-error-text ">*Required</div>}
                    </div>
                    <div className="button-conatiner" onClick={() => {
                        if (codes.join('') === "") {
                            setError(true)
                        }
                        if (codes.join('') !== "" && !isVerifyLoading) {
                            onVerify()
                        }
                    }}>{isVerifyLoading && <div className="loader-btn" />}Verify Now</div>
                    <div className="verification-content">We have sent an email with a verification to your email address. In order to complete the sign-up process, Please check your email and enter the verification code above. If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form. If you need assistance, please contact us.</div>
                </div>
            </div>
        </Popup>
    )
}
export default EmailVerifyModal